












































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { DictionaryApi } from "@/api/dictionaryApi";
import { message } from "ant-design-vue";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class DictionaryList extends Vue {
  dicApi = new DictionaryApi();
  selectedId = 0;
  treeData: Array<any> = [];
  info: object = {};
  autoExpand = true;
  searchKey = "";
  searchData = [];
  expandedKeys: Array<number> = [];
  // selectedKeys: Array<number> = [];
  isShowSlider = 0;
  refNews: Array<any> = [];
  refImageText: Array<any> = [];
  refDic: Array<any> = [];
  refVideo: Array<any> = [];
  refBook: Array<any> = [];
  rightSliderStyle = {};

  mounted() {
    document.addEventListener("scroll", this.scrollEvent, true);
    const id = this.$route.query["id"];
    if (id && id != "0") {
      this.selectedId = Number(id);
    }
    this.getTreeData();
  }

  destroyed() {
    document.removeEventListener("scroll", this.scrollEvent);
  }

  scrollEvent() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    if (scrollTop >= 200) {
      if (this.isShowSlider == 1) {
        this.rightSliderStyle = {
          top: "50%",
          transform: "translateY(-50%)",
          position: "fixed",
        };
      }
    } else {
      this.rightSliderStyle = {};
    }
  }

  showRightSlider() {
    this.isShowSlider = 1;
  }

  hideRightSlider() {
    this.isShowSlider = 0;
  }

  getExtInfo() {
    this.dicApi.getExtInfo(this.selectedId).then((res) => {
      this.refNews = res.data.refNews;
      this.refImageText = res.data.refImageText;
      this.refDic = res.data.refDic;
      this.refVideo = res.data.refVideo;
      this.refBook = res.data.refBook;
    });
  }

  @Watch("selectedId")
  getSelectedId(newVal: number, oldVal: number) {
    this.getDetail();
    this.getExtInfo();
  }

  viewDetail(id: number) {
    this.selectedId = id;
  }

  onSelect(selectedKeys: Array<object>, evenInfo: any) {
    const key = evenInfo.node.dataRef.key;
    // debugger
    if (evenInfo.node.dataRef.level != 4) {
      const index = this.expandedKeys.indexOf(key);
      if (index >= 0) {
        this.expandedKeys.splice(index, 1);
      } else {
        this.expandedKeys.push(Number(key));
      }
    }
    this.selectedId = parseInt(key.toString());
    // if (this.selectedKeys.length > 0) {
    //   this.selectedKeys[0] = this.selectedId;
    // } else {
    //   this.selectedKeys.push(this.selectedId);
    // }
  }

  getTreeData() {
    const data: Array<any> = [{ key: 0, title: 0, children: [] }];
    this.dicApi.getTreeData().then((res) => {
      if (res.data && res.data.length > 0) {
        res.data.forEach((item: any, index: number) => {
          if (item.LevelNum == 1) {
            this.expandedKeys.push(item.ID);
          } else if (item.ID == this.selectedId) {
            // this.selectedKeys.push(item.ID);
            this.expandedKeys.push(item.ParentId);
          }
          this.buildTreeData(data, item);
        });
        this.treeData = data[0].children;
        this.autoExpand = true;
      }
    });
  }

  buildTreeData(data: Array<any>, item: any) {
    data.forEach((value) => {
      if (value.key == item.ParentId) {
        if (!value.children) {
          value.children = [];
        }
        value.children.push({
          key: item.ID,
          title: item.DictionaryName,
          class: "level_" + item.LevelNum,
          level: item.LevelNum,
        });
      } else {
        if (value.children && value.children.length > 0) {
          this.buildTreeData(value.children, item);
        }
      }
    });
  }

  getDetail() {
    this.dicApi.getDictionaryDetail(this.selectedId).then((res) => {
      // const regex = new RegExp("<img", "gi");
      // res.data.Content = res.data.Content.replace(
      //   regex,
      //   `<img style="max-width: 100%; height: auto"`
      // );
      this.info = res.data;
    });
  }

  search() {
    if (this.searchKey != "") {
      this.selectedId = 0;
      this.dicApi.searchDictionary(this.searchKey).then((res) => {
        this.searchData = res.data;
      });
    } else {
      message.info("请输入要搜索的关键字");
    }
  }
}
